import { all, fork, put, take } from 'redux-saga/effects';
import { BOOTSTRAP_ROUTER } from '../iwRouter/IwRouter.actions';
import { ACTIVATE_MY_ACCOUNT } from './MyAccount.actions';
import { mainContentSagaWorkers } from './pageStructure/mainContent/MainContent.sagas';
import { iwModalsWorkers } from '../iwModals/IwModals.sagas';

export const myAccountSagaWorkers = [fork(bootstrapSagaWorker)];

function* bootstrapSagaWorker() {
    yield all([...mainContentSagaWorkers, ...iwModalsWorkers]);

    yield take(ACTIVATE_MY_ACCOUNT);
    yield put({ type: BOOTSTRAP_ROUTER });
}
